<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="SPU编码">
            <el-input v-model.trim="searchForm.spuCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="SPU名称">
            <el-input v-model.trim="searchForm.spuName" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="大型号">
            <el-input v-model.trim="searchForm.bigModel" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="上传类别">
            <el-select v-model="searchForm.category" filterable clearable @change="onSearch">
              <el-option label="全部" value="" />
              <el-option v-for="item in ['新品', '新品增配', '老品优化']" :label="item" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间:">
            <form-date-range :form="searchForm" startKey="uploadDateStart" :usingTime="false" endKey="uploadDateEnd" valueFormat="yyyy-MM-dd">
            </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        @sort-change="handleSortChange"
        highlight-current-row
        :data="tableData.records"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="spuCode" label="SPU编码" min-width="100"></el-table-column>
        <el-table-column show-overflow-tooltip prop="spuName" label="SPU名称" min-width="180"></el-table-column>
        <el-table-column prop="bigModel" label="大型号" min-width="100"></el-table-column>
        <el-table-column prop="category" label="上传类别" min-width="80"></el-table-column>
        <el-table-column prop="uploadDate" label="上传时间" min-width="140" sortable="custom"></el-table-column>
        <el-table-column prop="imgNum" label="图片数量" min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sharedAddress" label="共享盘地址" min-width="250"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button type="text" v-copy="row.sharedAddress">复制地址</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import axios from '@/utils/axiosInstance';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      searchForm: {
        category: '',
      },
      exportData: {},
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSort();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.searchFormData = data;
      this.$q.newProduct
        .sliceAddressListPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.searchForm = {
        category: '',
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.searchForm.sortDesc = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '',
      this.init();
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData.filterData
        },
        reportName: 'sliceUpAddressExport'
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important
</style>
